import { Td } from '@chakra-ui/react';
import { orderTypeOptions } from '../enums/orderTypeOptions';

const OrderType = ({ type }) => {
  return <Td>{orderTypeOptions[type] || 'Not Available'}</Td>;
};
export default OrderType;
